<template>
  <div class="training-dashboard-block">
    <div class="training-dashboard-count-item">
      <div class="training-dashboard-count-num">
        <span class="num">{{ finishCount }}</span>天
      </div>
      <span class="text">已完成</span>
    </div>
    <div class="training-dashboard-count-item">
      <div class="training-dashboard-count-num">
        <span class="num">{{ continueCount }}</span>天
      </div>
      <span class="text">连续打卡</span>
    </div>
    <div class="training-dashboard-count-item">
      <div class="training-dashboard-count-num">
        <span class="num">{{ readCount }}</span>字
      </div>
      <span class="text">已阅读</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TrainingDashboard',
    props: {
      finishCount: {
        type: Number,
        required: true,
      },
      continueCount: {
        type: Number,
        required: true,
      },
      readCount: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-dashboard-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .training-dashboard-count-item {
    flex: 1;
    text-align: center;
    color: @color-text-light;
    line-height: 1;
  }

  .training-dashboard-count-num {
    color: @color-text-base;
    margin-bottom: @size-small;
    .num {
      font-size: @font-size-extra-extra-large;
      margin-right: @size-extra-small / 2;
    }
  }
</style>
